import { useRef, useState } from 'react';
import { Layers, Bot, RefreshCw, Server, GitBranch, FileJson, Info, ChevronLeft, ChevronRight } from 'lucide-react';

function Projects() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const projects = [
    {
      number: "1",
      title: "Application de gestion des dépenses",
      description: "Application de suivi des dépenses personnelles développée en ReactJS avec l'API Chrome pour le stockage local et les notifications.",
      icon: <Layers size={20} />,
      tags: ["ReactJS", "Chrome API", "JavaScript"],
      gradient: "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)"
    },
    {
      number: "2",
      title: "Application d'arbre généalogique (Familia)",
      description: "Application web pour créer et visualiser des arbres généalogiques. Frontend Angular avec backend SpringBoot pour la gestion des données.",
      icon: <Bot size={20} />,
      tags: ["Angular", "SpringBoot", "Java", "TypeScript"],
      gradient: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)"
    },
    {
      number: "3",
      title: "Application d'événement festive",
      description: "Plateforme pour la gestion et l'organisation d'événements festifs. Développée avec Angular et Django pour une expérience utilisateur fluide.",
      icon: <RefreshCw size={20} />,
      tags: ["Angular", "Django", "Python", "TypeScript"],
      gradient: "linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)"
    },
    {
      number: "4",
      title: "Veille & expérimentations",
      description: "Exploration continue de nouvelles librairies frontend, contributions open source et prototypage de micro-outils autour de React et TypeScript.",
      icon: <GitBranch size={20} />,
      tags: ["React", "TypeScript", "Open Source"],
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)"
    }
  ];

  const updateScrollState = () => {
    const track = trackRef.current;
    if (!track) return;
    setCanScrollLeft(track.scrollLeft > 0);
    setCanScrollRight(track.scrollLeft < track.scrollWidth - track.clientWidth - 1);
  };

  const scrollBy = (direction: 'left' | 'right') => {
    const track = trackRef.current;
    if (!track) return;
    const cardWidth = track.firstElementChild?.clientWidth || track.clientWidth;
    const gap = 24;
    const distance = cardWidth + gap;
    track.scrollBy({
      left: direction === 'left' ? -distance : distance,
      behavior: 'smooth'
    });
    setTimeout(updateScrollState, 350);
  };

  return (
    <div className="projects">
      <div className="projects-header">
        <div>
          <h1 className="page-title">Mes side projets</h1>
          <p className="page-subtitle">De l'idée au prototype : tous mes projets sont rassemblés ici.</p>
        </div>
        <div className="carousel-controls">
          <button
            className="carousel-arrow"
            onClick={() => scrollBy('left')}
            disabled={!canScrollLeft}
            aria-label="Projets précédents"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            className="carousel-arrow"
            onClick={() => scrollBy('right')}
            disabled={!canScrollRight}
            aria-label="Projets suivants"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="projects-carousel">
        <div
          className="projects-track"
          ref={trackRef}
          onScroll={updateScrollState}
        >
          {projects.map((project, index) => (
            <div key={index} className="project-card-large">
              <div className="project-card-number">{project.number}</div>
              <div
                className="project-card-visual"
                style={{ background: project.gradient }}
              >
                <div className="project-icon">{project.icon}</div>
              </div>
              <div className="project-card-body">
                <a href="#" className="project-title-link"><h3>{project.title}</h3></a>
                <div className="project-tags">
                  {project.tags.map((tag, tagIndex: number) => (
                    <span key={tagIndex} className="tag">{tag}</span>
                  ))}
                </div>
                <p>{project.description}</p>
                <a href="#" className="read-more">
                  En savoir plus <span>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
